function storeDetailManipulation() {
  if (!document.body.matches(".type-post.in-predajne-miesta")) return;
  const detailImage = document
    .querySelector('span[itemprop="image"] > meta[itemprop="url"]')
    .getAttribute("content");
  const headLine = document.querySelector('h1[itemprop="headline"]');
  const articleDetailWrap = document.querySelector(".news-item-detail");
  if (!articleDetailWrap) return;
  const headLineWrap = document.createElement("div");
  headLineWrap.className = "store-detail-headline";
  headLineWrap.appendChild(headLine);
  const detailImageWrap = document.createElement("div");
  detailImageWrap.className = "store-detail-image";
  const detailImageEl = document.createElement("img");
  detailImageEl.src = detailImage;
  detailImageEl.alt = headLine.textContent;
  detailImageWrap.appendChild(detailImageEl);
  headLineWrap.appendChild(detailImageWrap);
  articleDetailWrap.appendChild(headLineWrap);
  document
    .querySelectorAll("div.extra-opening-inner.block-text")
    .forEach((element) => {
      if (element.textContent.trim() === "") {
        element.style.display = "none";
      }
    });
}

export { storeDetailManipulation };
